import { Typography, Row, Col, Carousel, Card, Tag, Button, Tabs, Rate, Divider, List, Avatar, Form, Input} from 'antd';
import { EnvironmentOutlined, PhoneOutlined, ClockCircleOutlined, GlobalOutlined, HeartOutlined, HeartFilled, CheckCircleOutlined,FireOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from "../utils/BaseUrl";
import Swal from 'sweetalert2';



const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { TextArea } = Input;
const user = JSON.parse(localStorage.getItem('user'));
const userRole = user?.role || null;


const DetailContainer = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 24px;
  
  @media (max-width: 768px) {
    padding: 0 16px;
    margin: 24px auto;
  }
`;

const StyledCarousel = styled(Carousel)`
  .slick-dots {
    margin-bottom: 24px;
  }

  .slick-slide img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    border-radius: 8px;
  }
  
  @media (max-width: 768px) {
    .slick-slide img {
      height: 300px;
    }
  }
`;

const DetailCard = styled(Card)`
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const PriceTag = styled(Tag)`
  font-size: 16px;
  padding: 4px 12px;
  border-radius: 4px;
  margin-left: 16px;
`;

const AmenityItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  
  .anticon {
    color: #52c41a;
    margin-right: 8px;
  }
`;

// Create a custom ReviewComment component to replace the Comment component
const ReviewComment = ({ author, avatar, content, datetime }) => (
  <div style={{ marginBottom: 16 }}>
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <Avatar src={avatar} alt={author} />
      <div style={{ marginLeft: 12 }}>
        <Text strong>{author}</Text>
        <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: 12, marginBottom: 4 }}>{datetime}</div>
        {content}
      </div>
    </div>
  </div>
);

const DetailFitnessPage = () => {
  const location = useLocation();
  const [liked, setLiked] = useState(false);
  const { id } = useParams();
  const [gym, setGym] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [form] = Form.useForm();
  const [packages, setPackages] = useState([]);
    const [totalPaid, setTotalPaid] = useState(null);
    const [loading, setLoading] = useState(true);

  // Lấy thông tin gymId từ API
  useEffect(() => {
  if (!id) return;

  const fetchData = async () => {
    try {
      // 1. Lấy thông tin Gym
      const gymRes = await axios.get(`${API_BASE_URL}/api/Gym/getGymID?id=${id}`);
      const gymData = gymRes.data;
      setGym(gymData);
      console.log('Dữ liệu gym nhận được:', gymData);


      // 2. Lấy danh sách Package của Gym
      const packageRes = await axios.get(`${API_BASE_URL}/api/Package/getPackageByGymId?gymId=${id}`);
      setPackages(packageRes.data);

      // 3. Lấy tổng tiền đã thanh toán của Gym
      const totalRes = await axios.get(`${API_BASE_URL}/api/PaymentGymPackage/total-paid/${id}`);
      setTotalPaid(totalRes.data.totalPaid);
    } catch (err) {
      console.error("Lỗi khi tải dữ liệu:", err);
      setTotalPaid(0);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [id]);





// Lấy danh sách reviews từ API
  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/Review/GetByGymId?gymId=${id}`);
      setReviews(res.data);
    } catch (err) {
      console.error("Lỗi khi lấy review:", err);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [id]);

  // Gửi review mới
  const handleSubmitReview = async (values) => {
    try {
      const user = JSON.parse(localStorage.getItem("user")).userId; // Lấy thông tin user từ localStorage
      await axios.post(`${API_BASE_URL}/api/Review/create_review?userId=${user}`, {
        gymId: id,
        rating: values.rating,
        comment: values.review
      }  );

      form.resetFields(); // Reset form sau khi gửi
      fetchReviews();     // Reload danh sách review
      Swal.fire({
      icon: 'success',
      title: 'Gửi đánh giá thành công!',
      text: 'Cảm ơn bạn đã đánh giá phòng gym.',
      confirmButtonColor: '#3085d6'
    });
    } catch (err) {
      console.error("Lỗi khi gửi review:", err);
      Swal.fire({
      icon: 'error',
      title: 'Lỗi!',
      text: 'Không thể gửi đánh giá. Vui lòng thử lại.',
      confirmButtonColor: '#d33'
    });
    }
  };
  




  // Mock data for fitness center details
  const fitnessData = {
    id: id || '1',
    name: 'FlexGym Fitness Center',
    rating: 4.8,
    reviewCount: 124,
    price: '800k - 1.2M VND',
    location: '123 Fitness Street, District 1, HCMC',
    phone: '+84 123 456 789',
    website: 'www.flexgymfitnesscenter.com',
    openHours: '06:00 - 22:00',
    description: 'FlexGym Fitness Center is a premium fitness facility located in the heart of Ho Chi Minh City. With state-of-the-art equipment, professional trainers, and a wide range of fitness classes, we provide the perfect environment for you to achieve your fitness goals.',
    images: [
      'https://i.pinimg.com/736x/5a/f4/96/5af496e575105b81072cdaaa6fe6ba28.jpg',
      'https://athletechnews.com/wp-content/uploads/2022/04/ORANGETHEORY-flagship-NYC-location-news.jpg',
      'https://cdn.prod.website-files.com/6629184900a2ef9802de6081/677e192a17fa0aaceffe2a2c_home-section-1%20-%202.webp',
    ],
    amenities: [
      'Modern Equipment',
      'Swimming Pool',
      'Sauna & Steam Room',
      'Group Classes',
      'Personal Training',
      'Locker Rooms',
      'Nutrition Consulting',
      'Parking',
      'Towel Service',
      'Wifi',
    ],
    classes: [
      { name: 'Yoga', time: 'Mon, Wed, Fri: 07:00 - 08:00', instructor: 'Jane Smith' },
      { name: 'Zumba', time: 'Tue, Thu: 18:00 - 19:00', instructor: 'Mike Johnson' },
      { name: 'HIIT', time: 'Mon, Wed, Fri: 18:30 - 19:30', instructor: 'David Lee' },
      { name: 'Spinning', time: 'Tue, Thu, Sat: 08:00 - 09:00', instructor: 'Sarah Brown' },
    ],
    reviews: [
      { 
        author: 'John Doe', 
        avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png', 
        rating: 5, 
        content: 'Great facilities and professional staff. The swimming pool is amazing!', 
        date: '2023-03-15' 
      },
      { 
        author: 'Jane Smith', 
        avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png', 
        rating: 4, 
        content: 'Modern equipment and clean environment. The only thing I would improve is the locker room space.', 
        date: '2023-02-28' 
      },
      { 
        author: 'Mike Johnson', 
        avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png', 
        rating: 5, 
        content: 'I love the yoga classes here! The instructors are very knowledgeable and helpful.', 
        date: '2023-02-10' 
      },
    ],
    memberships: [
      { type: 'Daily Pass', price: '10.000 VND', description: 'Full access for one day' },
      { type: 'Monthly', price: '1.2M VND', description: 'Unlimited access to all facilities' },
      { type: 'Quarterly', price: '3M VND', description: 'Save 15% compared to monthly plan' },
      { type: 'Annual', price: '10M VND', description: 'Best value, save 30% compared to monthly plan' },
    ],
    trainers: [
      { name: 'John Smith', specialty: 'Weight Training', experience: '8 years', avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png' },
      { name: 'Sarah Lee', specialty: 'Yoga', experience: '6 years', avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png' },
      { name: 'Mike Brown', specialty: 'Cardio & HIIT', experience: '5 years', avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png' },
    ]
  };
  const handleLike = () => {
    setLiked(!liked);
  };
  
 

  
    

  return (
    
    <DetailContainer>
      {/* Image Carousel */}
      <StyledCarousel autoplay>
        {fitnessData.images.map((image, index) => (
          <div key={index}>
            <img src={image} alt={`${fitnessData.name} - ${index + 1}`} />
          </div>
        ))}
      </StyledCarousel>
      
      {userRole === "GymOwner" && (
  <div style={{
    background: '#fffde7',
    border: '2px solid #ffb300',
    borderRadius: 12,
    boxShadow: '0 4px 10px #ffcc8044',
    fontFamily: 'Montserrat, sans-serif',
    width: 250,
    padding: 16,
    textAlign: 'center',
    margin: '24px auto',
  }}>
    <h3 style={{ color: '#f57c00', marginBottom: 8 }}>💰 Ví doanh thu</h3>
    {loading ? (
      <p>Đang tải...</p>
    ) : (
      <div style={{ fontSize: 24, fontWeight: 700, color: '#388e3c' }}>
        {totalPaid?.toLocaleString('vi-VN')} VND
      </div>
    )}
  </div>
)}

      {/* Main Info Section */}
      <Row gutter={24}>
        <Col xs={24} lg={16}>
          <DetailCard>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
              <div>
                <Title level={2} style={{ marginBottom: 8 }}>
                  {gym?.name}
                  {/* <PriceTag color="#F15637">{fitnessData.price}</PriceTag> */}
                </Title>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <Rate
                  disabled
                  allowHalf
                  value={gym?.rating || 0}
                  style={{ fontSize: 16, color: '#faad14' }} // màu vàng mặc định
                />
                <Text style={{ marginLeft: 8 }}>{gym?.rating ?? 0} (reviews)</Text>
              </div>
              </div>
              <Button 
                type="default" 
                icon={liked ? <HeartFilled style={{ color: '#F15637' }} /> : <HeartOutlined />} 
                onClick={handleLike}
                size="large"
              >
                {liked ? 'Saved' : 'Save'}
              </Button>
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 8 }}>
                <EnvironmentOutlined style={{ marginRight: 8, marginTop: 4 }} />
                <Text>{gym?.address}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 8 }}>
                <PhoneOutlined style={{ marginRight: 8, marginTop: 4 }} />
                <Text>{gym?.phoneNumber}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 8 }}>
                <GlobalOutlined style={{ marginRight: 8, marginTop: 4 }} />
                <Text>{gym?.website}</Text>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <ClockCircleOutlined style={{ marginRight: 8, marginTop: 4 }} />
                <Text>{gym?.openingHours}</Text>
              </div>
            </div>
            <Divider style={{ margin: '16px 0' }} />
            <div>
              <Title level={4}>About {gym?.name}</Title>
              <Paragraph>{gym?.description}</Paragraph>
            </div>
          </DetailCard>
          {/* Tabs for different sections */}
          <DetailCard>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Amenities" key="1">
                <Row gutter={[16, 8]}>
                  {fitnessData.amenities.map((amenity, index) => (
                    <Col xs={24} sm={12} key={index}>
                      <AmenityItem>
                        <CheckCircleOutlined />
                        <Text>{amenity}</Text>
                      </AmenityItem>
                    </Col>
                  ))}
                </Row>
              </TabPane>
              <TabPane tab="Classes" key="2">
                <List
                  itemLayout="horizontal"
                  dataSource={fitnessData.classes}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        title={item.name}
                        description={
                          <>
                            <div><Text strong>Time:</Text> {item.time}</div>
                            <div><Text strong>Instructor:</Text> {item.instructor}</div>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
              </TabPane>
              <TabPane tab="Reviews" key="3">
                <List
                  itemLayout="horizontal"
                  dataSource={reviews}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar>{item.userName?.[0]}</Avatar>}
                        title={
                          <>
                            <strong>{item.userName}</strong> • {new Date(item.createdAt).toLocaleString()}
                          </>
                        }
                        description={
                          <>
                            <Rate disabled defaultValue={item.rating} style={{ fontSize: 12, marginBottom: 4 }} />
                            <p style={{ margin: 0 }}>{item.comment}</p>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />


          <Divider />

          <Title level={4}>Write a Review</Title>
          <Form form={form} onFinish={handleSubmitReview} layout="vertical">
            <Form.Item
              name="rating"
              label="Your Rating"
              rules={[{ required: true, message: 'Please rate' }]}
            >
              <Rate />
        </Form.Item>

        <Form.Item
          name="review"
          label="Your Review"
          rules={[{ required: true, message: 'Please write your review' }]}
        >
          <TextArea rows={4} placeholder="Write your review here..." />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit Review
          </Button>
        </Form.Item>
      </Form>
              </TabPane>
              <TabPane tab="Trainers" key="4">
                <List
                  itemLayout="horizontal"
                  dataSource={fitnessData.trainers}
                  renderItem={item => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={<Avatar src={item.avatar} size={64} />}
                        title={item.name}
                        description={
                          <>
                            <div><Text strong>Specialty:</Text> {item.specialty}</div>
                            <div><Text strong>Experience:</Text> {item.experience}</div>
                          </>
                        }
                      />
                    </List.Item>
                  )}
                />
              </TabPane>
            </Tabs>
          </DetailCard>
        </Col>
        {/* Sidebar with Memberships */}
        <Col xs={24} lg={8}>
          <DetailCard title="🏋️ Gói tập - Membership Options">
            <List
              itemLayout="vertical"
              dataSource={packages}
              renderItem={(item) => {
                let features = [];
                try {
                  const parsed = JSON.parse(item.features);
                  features = Object.keys(parsed).filter(key => parsed[key]); // lấy key có value true
                } catch (e) {
                  console.error("Lỗi parse features:", e);
                }

                return (
                  <List.Item
                    key={item.packageId}
                    style={{ border: '1px solid #f0f0f0', borderRadius: 12, padding: 16, marginBottom: 16 }}
                    extra={
                      <Button
  onClick={async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.userId;

      // 👉 Nếu chưa đăng nhập
      if (!userId) {
        await Swal.fire({
          icon: 'warning',
          title: 'Chưa đăng nhập!',
          text: 'Vui lòng đăng nhập để tiếp tục chọn gói tập.',
        });
        return;
      }

      const response = await fetch(
        `${API_BASE_URL}/api/PaymentGymPackage/paymentpackageById?packageId=${item.packageId}&userId=${userId}`
      );

      if (response.ok) {
        const result = await response.json();
        // 👉 Mở trang thanh toán
        window.open(result.checkoutUrl, '_blank');
      } else {
        const errorText = await response.text();
        console.error('Lỗi khi gọi API:', response.status, errorText);

        Swal.fire({
          icon: 'error',
          title: 'Thanh toán thất bại',
          text: 'Vui lòng thử lại sau.',
        });
      }
    } catch (error) {
      console.error('Lỗi kết nối:', error);
      Swal.fire({
        icon: 'error',
        title: 'Lỗi kết nối',
        text: 'Không thể kết nối đến máy chủ.',
      });
    }
  }}
  type="primary"
  shape="round"
  size="middle"
>
  Chọn gói
</Button>


                    }
                  >
                    <List.Item.Meta
                      title={
                        <Text strong style={{ fontSize: 18 }}>
                          <FireOutlined style={{ color: '#F15637', marginRight: 8 }} />
                          {item.name}
                        </Text>
                      }
                      description={
                        <>
                          <div style={{ marginTop: 4 }}>
                            <Text style={{ fontSize: 15, color: '#F15637' }}>
                              💰 {item.price.toLocaleString()} VND
                            </Text>
                          </div>
                          <div style={{ marginTop: 4 }}>
                            <ClockCircleOutlined style={{ marginRight: 6 }} />
                            Thời hạn: {item.durationValue} {item.durationType}
                          </div>
                          {item.discountPercent > 0 && (
                            <div style={{ marginTop: 4 }}>
                              🎁 Giảm giá: {item.discountPercent}%
                            </div>
                          )}

                          {/* Danh sách tiện ích */}
                          {features.length > 0 && (
                            <div style={{ marginTop: 12 }}>
                              <Text strong style={{ fontSize: 15, color: '#444' }}>
                                🎯 Tiện ích bao gồm:
                              </Text>
                              <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8 }}>
                                {JSON.parse(item.features).map((feature, index) => (
                                  <Tag
                                    key={index}
                                    icon={<CheckCircleOutlined />}
                                    color="success"
                                    style={{
                                      fontSize: 14,
                                      padding: '6px 14px',
                                      borderRadius: 20,
                                      width: 'fit-content'
                                    }}
                                  >
                                    {feature}
                                  </Tag>
                                ))}
                              </div>
                            </div>
                          )}

                        </>
                      }
                    />
                  </List.Item>
                );
              }}
            />
          </DetailCard>
          <DetailCard title="Contact Us">
            <Form layout="vertical">
              <Form.Item name="name" label="Your Name" rules={[{ required: true }]}>
                <Input placeholder="Enter your name" />
              </Form.Item>
              <Form.Item name="email" label="Your Email" rules={[{ required: true, type: 'email' }]}>
                <Input placeholder="Enter your email" />
              </Form.Item>
              
              <Form.Item name="phone" label="Your Phone" rules={[{ required: true }]}>
                <Input placeholder="Enter your phone number" />
              </Form.Item>

              <Form.Item name="message" label="Message" rules={[{ required: true }]}>
                <TextArea rows={4} placeholder="Enter your message" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" block>
                  Send Message
                </Button>
              </Form.Item>
            </Form>
          </DetailCard>
        </Col>
      </Row>
    </DetailContainer>
  );
};

export default DetailFitnessPage; 